import React from 'react'
import { Redirect } from 'react-router-dom'
import hasAccess from 'components/Helpers/hasAccess'
import { navGroups } from 'components/Navigations/Sidebar'

const env = () => (
  /.*admin.evofitness.*/.test(window.location.origin) ? 'production' : 'staging'
)

const LandingRedirect = ({ user, operatorID }) => {
  if (!operatorID) return null

  const groups = navGroups(operatorID, env())
  for (const group of groups) {
    for (const link of group.links) {
      if (link.betaUsers && link.betaUsers.length > 0) continue
      if (!link.permission) continue
      if (hasAccess(user, link.permission)) {
        return <Redirect to={link.path} />
      }
    }
  }
  return <Redirect to='/no-access' />
}

export default LandingRedirect
